import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListService } from '@fry/lib/list';

@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    providers: [
        ListService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RolesComponent { }
